var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-2.4 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7986 18.8274C15.0606 18.8274 18.5156 15.2284 18.5156 10.7888C18.5156 6.34925 15.0606 2.75027 10.7986 2.75027C6.53659 2.75027 3.08157 6.34925 3.08157 10.7888C3.08157 15.2284 6.53659 18.8274 10.7986 18.8274Z",
    stroke: "#D1D1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0677 16.7083L20.4391 21.25",
    stroke: "#D1D1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4b6eb51e89ecd0a1dd8708c2b35293a5.svg";
export { ForwardRef as ReactComponent };